
export default [
	"JmRowActionEdit",
	"JmRowActionDelete"
];



// WEBPACK FOOTER //
// ./src/services/components/actions/asset.js